import React, {useState, useEffect} from 'react';
import './style.css';
import img1 from '../../assets/img1.jpg';
import img2 from '../../assets/img2.jpg';
import img3 from '../../assets/img3.jpg';
import voltar from '../../assets/voltarIcon.png'
import prosseguir from '../../assets/passarIcon.png'

const images = [img1, img2, img3];

const Carousel: React.FC = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
  };

  const prevImage = () => {
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextImage();
    }, 5000); // 5000ms = 5s

    return () => clearInterval(interval); // Limpa o intervalo ao desmontar o componente
  }, [currentImageIndex]);
  
  return (
    <div className="carousel-container">
      <button onClick={prevImage} className="carousel-button carousel-button-left"><img src={voltar} alt='voltar' /></button>
      <img src={images[currentImageIndex]} alt="carousel" className="carousel-image" />
      <button onClick={nextImage} className="carousel-button carousel-button-right"><img src={prosseguir} alt='proxima'/></button>
    </div>
  );
};

export default Carousel;
